module.exports = __webpack_public_path__ + "img/hand-rig-multi-thumb.395a4c32.jpg";